(function(angular){
	'use strict';
	
	angular
		.module('redemptionRequestModule')
		.controller('RedemptionRequestAcknowledgements', [
			'globalConfig',
			'HTTP_STATUS',
			'INVESTMENT_ENTITY_ID',
			'mixpanelFactory',
			'urlFactory',
			RedemptionRequestAcknowledgementsFunction
		]);
	
	function RedemptionRequestAcknowledgementsFunction(
		globalConfig,
		HTTP_STATUS,
		INVESTMENT_ENTITY_ID,
		mixpanelFactory,
		urlFactory
	){
		var redemptionAcknowledgements = this;

		var ipoAcknowledgements = [
			'I certify that I am authorized to make these elections and that all information provided is true and accurate.',
			'I agree that Rise Companies Corp. is entitled to act on the instructions of this redemption request, without further inquiry, and these instructions supersede and have priority over all previous instructions in respect to the shares requested to be redeemed.',
			'I authorize Rise Companies Corp. to direct the transfer agent of applicable Rise Companies Offering issuer(s) to execute this redemption request and update the books and records of such Rise Companies Offering issuer(s) accordingly.',
			'I further certify that no tax or legal advice has been given to me by the Rise Companies Offering issuer, Fundrise Advisors, LLC, or any agent of any of them, and that all decisions regarding the elections made on this form are my own.',
			'I expressly assume responsibility for any adverse consequences that may arise from the redemption request, and agree that Rise Companies, nor any of its respective affiliates, shall in any way be responsible, and shall be indemnified and held harmless, for any tax, legal, or other consequences of the redemption request(s) submitted hereby.'
		];

		var standardAcknowledgments = [
			'I certify that I am authorized to make these elections and that all information provided is true and accurate.',
			'I agree that Fundrise Advisors, LLC is entitled to act on the instructions of this redemption request, without further inquiry, and these instructions supersede and have priority over all previous instructions in respect to the shares requested to be redeemed.',
			'I authorize Fundrise Advisors, LLC to direct the transfer agent of applicable eREIT&#8482; issuer(s) to execute this redemption request and update the books and records of such eREIT&#8482; issuer(s) accordingly.',
			'I further certify that no tax or legal advice has been given to me by an eREIT&#8482; issuer, Fundrise Advisors, LLC, or any agent of any of them, and that all decisions regarding the elections made on this form are my own.',
			'I expressly assume responsibility for any adverse consequences that may arise from the redemption request, and agree that none of the eREIT&#8482; issuers, Fundrise Advisors, LLC or any of their respective affiliates shall in any way be responsible, and shall be indemnified and held harmless, for any tax, legal or other consequences of the redemption request(s) submitted hereby.'
		];

		redemptionAcknowledgements.$onInit = function() {
			redemptionAcknowledgements.isIpo = urlFactory.urlContains('/ipo');
			angular.extend(redemptionAcknowledgements, globalConfig);
			mixpanelFactory.track('Redemption Request Acknowledgements Viewed');
			redemptionAcknowledgements.acknowledgments = redemptionAcknowledgements.isIpo ? ipoAcknowledgements : standardAcknowledgments;
		};

		function getAcknowledgementState(){
			return redemptionAcknowledgements.selectedAcks.every(function(ack){
				return ack.selected;
			});
		}

		redemptionAcknowledgements.submit = function() {
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/redemption-request/submit-request';

			var data = {};
			angular.extend(data,globalConfig.redemptionRequestForm);
			data.allAcknowledgementsAccepted = getAcknowledgementState();

			return urlFactory.apiPostPromise(url, data)
				.then(function() {
					if (redemptionAcknowledgements.isIpo) {
						return urlFactory.redirect('/ipo/redemptions/success');
					}
					else {
						return urlFactory.redirect('/reits/redemptions/success');
					}
				})
				.catch(function() {
					if (redemptionAcknowledgements.isIpo) {
						return urlFactory.redirect('/ipo/redemptions/request/error');
					}
					else {
						return urlFactory.redirect('/reits/redemptions/request/error');
					}
				});
		};
	}
})(window.angular);